import config from "../config/config"
import { callService } from "./CommonService";

const APIUrlBase = config.apiHost + config.apiBase + 'occupation-subareas';

/* Retrieve list of all occupation subareas in the system */
async function getOccupationSubareas() {
    const url = APIUrlBase;
    return await callService(url);
}

/* Retrieve one single occupation subarea data */
async function getOccupationSubarea(occupationSubareaId) {
    const url = APIUrlBase + '/' + occupationSubareaId;
    return await callService(url);
}

/* Call API service to update an occupation subarea */
async function updateOccupationSubarea(occupationSubareaId, data) {
    const url = APIUrlBase + '/' + occupationSubareaId;
    const method = 'PATCH';
    const payload = {
        key: data.key,
        name: data.name,
        occupationAreaId: data.occupationAreaId,
    };
    return await callService(url, method, payload);
}

/* Call API service to create an occupation subarea */
async function createOccupationSubarea(data) {
    const url = APIUrlBase;
    const method = 'POST';
    const payload = {
        key: data.key,
        name: data.name,
        occupationAreaId: data.occupationAreaId,
    };
    return await callService(url, method, payload);
}

/* Call API service to delete an occupation subarea */
async function deleteOccupationSubarea(occupationSubareaId) {
    const url = APIUrlBase + '/' + occupationSubareaId;
    const method = 'DELETE';
    return await callService(url, method);
}

export default { getOccupationSubareas, getOccupationSubarea, updateOccupationSubarea, createOccupationSubarea, deleteOccupationSubarea };
